"use client";

import { useLayoutEffect, useRef } from "react";

import { Search } from "@/components/search/search.component";
import { Select } from "@/components/select/select.component";
import { SelectOption } from "@/components/select/selectOption.component";

import { applyShopFilters } from "@/shop/actions";
import {
  type ShopSortValue,
  SORT_OPTIONS,
  SHOP_SORT_FOCUS_STORAGE_KEY,
} from "@/shop/constants";

export const ProductSortSearch = ({
  defaultCategory,
  defaultSearch,
  defaultSort,
}: ProductSortSearchProps) => {
  const formRef = useRef<HTMLFormElement>(null);
  const submitRequest = () => {
    formRef.current?.requestSubmit();
  };
  const submitSortRequest = () => {
    sessionStorage.setItem(SHOP_SORT_FOCUS_STORAGE_KEY, "1");
    submitRequest();
  };

  useLayoutEffect(() => {
    if (!sessionStorage.getItem(SHOP_SORT_FOCUS_STORAGE_KEY)) return;
    sessionStorage.removeItem(SHOP_SORT_FOCUS_STORAGE_KEY);
    formRef.current
      ?.querySelector<HTMLSelectElement>('select[name="sort"]')
      ?.focus();
  }, [defaultSort]);

  return (
    <form
      action={applyShopFilters}
      ref={formRef}
      data-testid="shop-page-product-filtering">
      <input
        type="hidden"
        name="category"
        value={defaultCategory}
        readOnly
        aria-hidden
      />
      <section className="mt-10 grid w-full grid-cols-2 items-center justify-between gap-2">
        <div className="w-full min-w-0 md:w-fit">
          <Select name="sort" value={defaultSort} onChange={submitSortRequest}>
            {SORT_OPTIONS.map(({ value, label }) => (
              <SelectOption key={value} value={value}>
                {label}
              </SelectOption>
            ))}
          </Select>
        </div>
        <div className="w-full min-w-0 md:w-fit md:min-w-81.5 md:justify-self-end">
          <Search
            name="search"
            id="search"
            placeholder="Search"
            defaultValue={defaultSearch}
            debounce
            onChange={submitRequest}
            onReset={submitRequest}
          />
        </div>
      </section>
    </form>
  );
};

type ProductSortSearchProps = {
  defaultCategory: string;
  defaultSearch: string;
  defaultSort: ShopSortValue;
};
